"use client";

import React from "react";
import { Hero } from "../components/Hero";
import { Skills } from "./Skills";
import { Contact } from "../components/Contact";
import { Education } from "../components/Education";
import WorkExperience from "../components/WorkExperience";
import Projects from "../components/Projects";
import ScrollSkew from "../components/motion/ScrollSkew";
import Marquee from "../components/fancy/Marquee";
export default function PortfolioPage() {
  return (
    <div
      id="home"
      className="relative bg-white dark:bg-gray-900 transition-colors duration-300"
    >
      <Hero />

      <ScrollSkew>
        <Marquee
          items={[
            "React",
            "Tailwind",
            "Express.js",
            "Django",
            "C/C++",
            "Python",
            "JavaScript",
            "HTML",
            "CSS",
            "Swift",
            "Linux",
            "Git",
            "AWS",
            "Machine Learning",
            "Data Science",
            "Pandas",
            "Dev Ops",
            "MATLAB",
            "Manufacturing",
            "DFM",
            "3D Printing",
            "2D/3D CAD",
            "Simens NX",
            "SolidWorks",
            "Validation",
          ]}
          speed={58}
          className="py-6"
        />
      </ScrollSkew>
      <Skills />

      <Education />
      <WorkExperience />
      <Projects />
      <Contact />
    </div>
  );
}
